import { render, staticRenderFns } from "./NewsWidget.vue?vue&type=template&id=13ceb2c5&scoped=true"
import script from "./NewsWidget.vue?vue&type=script&lang=ts"
export * from "./NewsWidget.vue?vue&type=script&lang=ts"
import style0 from "./NewsWidget.vue?vue&type=style&index=0&id=13ceb2c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ceb2c5",
  null
  
)

export default component.exports